<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/chVslY/image/9780802867667.jpg?1684514918694" alt="This image is the cover for the book Called to the Life of the Mind"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Called to the Life of the Mind
      </h1>
      <p class="bookDescription body article font2">
        <p>“I wasn’t supposed to spend my life in the world of scholarship,” Richard Mouw acknowledges at the beginning of <i>Called to the Life of the Mind.</i> Yet he has indeed spent his career in the academy -- and has become one of the most widely respected evangelical Christian scholars of our time.<br/><br/>In this wise little book Mouw defends Christian scholarship as an important and legitimate endeavor, responding in particular to those traditions that continue to be suspicious of intellectual pursuits. Writing in an inviting, conversational style, Mouw reflects candidly on the faithful Christian cultivation of the life of the mind and offers gentle advice on how Christians, especially evangelicals, might fruitfully navigate the world of the academy as followers of Jesus.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard J. Mouw
      </h2>
      
      <p class="authorDescription body article">Richard J. Mouw is president and professor of Christian philosophy at Fuller Theological Seminary, Pasadena, California. His many other books include <em>Uncommon Decency</em>, <em>Praying at Burger King</em>, and <em>Abraham Kuyper: A Short and Personal</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?44cb97b1